import React, { useState } from 'react';
import TapInput from '../components/ui/TapInput';
import TapSelect from '../components/ui/TapSelect';
import InputEmployeeSearch from '../pages/includes/ui/InputEmployeeSearch';
import InputVendorSearch from '../pages/includes/ui/InputVendorSearch';
import InputWalletSearch from '../pages/includes/ui/InputWalletSearch';
import InputCustomerSearch from '../pages/includes/ui/InputCustomerSearch';

const PaymentFromSelect = ({
    value = {},
    onChange,
    paymentFromOptions = [],
    disabled = false,
    required = false,
    containerHeight = "",
    fontSize = "",
    placeholder = "Select Payment From",
    vendorPlaceholder = "Search Vendor",
    employeePlaceholder = "Search Employee",
    walletPlaceholder = "Search Wallet",
    customerPlaceholder = "Search Customer",
    className = "",
    employeeSearchSiteIds = [],
    customerSearchSiteIds = [],
    isCustomerMulti = false,
    showCustomer = false,
    showWallet = false,
    inputClass = "col-sm-6",
    input2Class = "col-sm-3",
}) => {
    const [paymentFromType, setPaymentFromType] = useState(value?.payment_from || "vendor");
    const [paymentFromId, setPaymentFromId] = useState(value?.payment_from_id || "");
    const [searchedVendor, setSearchedVendor] = useState(value?.vendorData || null);
    const [searchedEmployee, setSearchedEmployee] = useState(value?.employeeData || null);
    const [searchedWallet, setSearchedWallet] = useState(value?.walletData || null);
    const [searchedCustomer, setSearchedCustomer] = useState(value?.customerData || []);

    const handlePaymentFromTypeChange = (selectedOption) => {
        const type = selectedOption ? selectedOption.value : "vendor";
        setPaymentFromType(type);
        setPaymentFromId("");
        setSearchedVendor(null);
        setSearchedEmployee(null);
        setSearchedWallet(null);
        setSearchedCustomer([]);

        if (onChange) {
            onChange({
                payment_from: type,
                payment_from_id: "",
                vendorData: null,
                employeeData: null,
                walletData: null,
                customerData: []
            });
        }
    };

    const handleVendorSelect = (selectedOption) => {
        setSearchedVendor(selectedOption);
        setPaymentFromId(selectedOption ? selectedOption.value : "");

        if (onChange) {
            onChange({
                payment_from: paymentFromType,
                payment_from_id: selectedOption ? selectedOption.value : "",
                vendorData: selectedOption || null,
                employeeData: null,
                walletData: null,
                customerData: []
            });
        }
    };

    const handleEmployeeSelect = (selectedOption) => {
        setSearchedEmployee(selectedOption);
        setPaymentFromId(selectedOption ? selectedOption.value : "");

        if (onChange) {
            onChange({
                payment_from: paymentFromType,
                payment_from_id: selectedOption ? selectedOption.value : "",
                vendorData: null,
                employeeData: selectedOption || null,
                walletData: null,
                customerData: []
            });
        }
    };

    const handleWalletSelect = (selectedOption) => {
        setSearchedWallet(selectedOption);
        setPaymentFromId(selectedOption ? selectedOption.value : "");

        if (onChange) {
            onChange({
                payment_from: paymentFromType,
                payment_from_id: selectedOption ? selectedOption.value : "",
                vendorData: null,
                employeeData: null,
                walletData: selectedOption || null,
                customerData: []
            });
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        const customerArray = selectedOption || [];
        setSearchedCustomer(customerArray);

        if (onChange) {
            onChange({
                payment_from: paymentFromType,
                payment_from_id: customerArray.length > 0 ? customerArray.map(c => c.value).join(',') : "",
                vendorData: null,
                employeeData: null,
                walletData: null,
                customerData: customerArray
            });
        }
    };

    const renderPaymentFromInput = () => {
        switch (paymentFromType) {
            case "vendor":
                return (
                    <InputVendorSearch
                        placeholder={vendorPlaceholder}
                        changeEvent={handleVendorSelect}
                        containerHeight={containerHeight}
                        fontSize={fontSize}
                        value={searchedVendor}
                        disabled={disabled}
                    />
                );
            case "employee":
                return (
                    <InputEmployeeSearch
                        placeholder={employeePlaceholder}
                        changeEvent={handleEmployeeSelect}
                        containerHeight={containerHeight}
                        fontSize={fontSize}
                        value={searchedEmployee}
                        disabled={disabled}
                        search_site_ids={employeeSearchSiteIds}
                    />
                );
            case "Wallet":
                return (
                    <InputWalletSearch
                        placeholder={walletPlaceholder}
                        changeEvent={handleWalletSelect}
                        containerHeight={containerHeight}
                        fontSize={fontSize}
                        value={searchedWallet}
                        disabled={disabled}
                    />
                );
            case "customer":
                return (
                    <InputCustomerSearch
                        changeEvent={handleCustomerSelect}
                        value={searchedCustomer && Array.isArray(searchedCustomer) && searchedCustomer.length > 0 ? searchedCustomer.map(a => { a.label = a.display_label; return a; }) : []}
                        isMulti={isCustomerMulti}
                        containerHeight={containerHeight}
                        fontSize={fontSize}
                        disabled={disabled}
                        search_site_ids={customerSearchSiteIds}
                    />
                );
            default:
                return (
                    <InputVendorSearch
                        placeholder={vendorPlaceholder}
                        changeEvent={handleVendorSelect}
                        containerHeight={containerHeight}
                        fontSize={fontSize}
                        value={searchedVendor}
                        disabled={disabled}
                    />
                );
        }
    };

  const getPaymentFromOptions = () => {
    let options = [...paymentFromOptions];
    
    const hasWallet = options.some(opt => 
        opt.value?.toLowerCase() === 'Wallet'
    );
    
    if (showWallet && !hasWallet) {
        options.push({ value: 'Wallet', label: 'Wallet' });
    }

    if (showCustomer && !options.find(opt => opt.value === 'customer')) {
        options.push({ value: 'customer', label: 'Customer' });
    }

    const seen = new Set();
    const uniqueOptions = options.filter(option => {
        const key = option.value?.toLowerCase();
        if (seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    });

    return uniqueOptions;
};
    return (
        <div className="payment-from-select-container row">
            <div className={`payment-from-type-select ${inputClass}`}>
                <TapSelect
                    options={getPaymentFromOptions()}
                    changeEvent={handlePaymentFromTypeChange}
                   value={getPaymentFromOptions().find(s => s.value?.toLowerCase() === paymentFromType?.toLowerCase())}
                    placeholder={placeholder}
                    required={required}
                    containerHeight={containerHeight}
                    fontSize={fontSize}
                    isDisabled={disabled}
                />
            </div>
            <div className={`payment-from-type-input ${input2Class}`}>
                {renderPaymentFromInput()}
            </div>
        </div>
    );
};

export default PaymentFromSelect;